// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"1c991051a5ceb176c75d","113":"3d1bb90521a6f06c135e","114":"60b777d4ce1545051a23","163":"a33bd54b5b2a35b0a828"}[chunkId] + ".chunk.js";
};